import * as React from "react";
import type { SVGProps } from "react";
const SvgLandmarkViewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.563 26.469H17.15C19.184 21 18.572 15.094 15.86 10.28h2.121a.645.645 0 0 0 .656-.656.645.645 0 0 0-.656-.656h-2.91A19.3 19.3 0 0 0 8.62 2.975l-.525-.284V.875a.645.645 0 0 0-.656-.656.645.645 0 0 0-.657.656v8.094H5.25a.645.645 0 0 0-.656.656c0 .372.284.656.656.656h1.531V26.47H3.063a.644.644 0 0 0-.657.656c0 .372.285.656.656.656h17.5a.645.645 0 0 0 .657-.656.645.645 0 0 0-.657-.656m-8.05-16.188h.48l-4.9 4.44v-4.44zm2.056.35a18 18 0 0 1 1.969 4.9H9.144zm-6.475 6.213h7.087l-7.087 4.681zm8.772.46c.218 1.574.24 3.193.021 4.79H9.625zm-3.413-8.335h-5.36V4.2a18.2 18.2 0 0 1 5.36 4.769m-5.36 17.5v-3.063h8.576a19.6 19.6 0 0 1-.919 3.063z"
    />
  </svg>
);
export default SvgLandmarkViewIcon;
